import Icon from 'veui/components/Icon'

Icon.register({
  'pc-and-cellphone': {
    paths: [
      {
        d: 'M29.33 10.67h-4V5.33C25.33 4.6 24.73 4 24 4H5.33C4.6 4 4 4.6 4 5.33v13.02L1.47 23.4c-.09.19-.14.4-.14.6v2.67c0 .73.6 1.33 1.34 1.33h14.66c0 .74.6 1.33 1.34 1.33h10.66c.74 0 1.34-.6 1.34-1.33V12c0-.74-.6-1.33-1.34-1.33zm-22.66-4h16v4h-4c-.74 0-1.34.6-1.34 1.33v5.33H6.67V6.67zM4 25.33v-1.02L6.16 20h11.17v5.33H4zm24 1.34h-7.96c0-.12-.01-.23-.04-.34v-13h8v13.34zM25.33 24a1.33 1.33 0 11-2.66 0 1.33 1.33 0 012.66 0z'
      }
    ],
    width: '32',
    height: '32'
  }
})
